import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import PilotsTab from "@/components/admin/PilotsTab";
import RaceTab from "@/components/admin/RaceTab";
import EventsTab from "@/components/admin/EventsTab";
import SponsorsTab from "@/components/admin/SponsorsTab";
import UsersTab from "@/components/admin/UsersTab";
import MaintenanceTab from "@/components/admin/MaintenanceTab";
import ContentTab from "@/components/admin/ContentTab";
import BrandingTab from "@/components/admin/BrandingTab";

export default function Admin() {
  const { user } = useAuth();
  if (user?.role !== "admin") return <Navigate to="/" replace />;

  return (
    <div data-testid="admin-page" className="space-y-6">
      <h2 className="font-racing font-bold text-xl sm:text-2xl uppercase tracking-wide text-white border-l-4 border-[#FFB703] pl-3">
        Race Control — Pannello Admin
      </h2>

      <Tabs defaultValue="gara">
        <TabsList className="flex flex-wrap h-auto gap-1 bg-[#1A1A1E] border border-[#3F3F4C] p-1">
          <TabsTrigger data-testid="admin-tab-race" value="gara">Diretta Gara</TabsTrigger>
          <TabsTrigger data-testid="admin-tab-pilots" value="piloti">Piloti</TabsTrigger>
          <TabsTrigger data-testid="admin-tab-events" value="eventi">Bonus/Malus</TabsTrigger>
          <TabsTrigger data-testid="admin-tab-sponsors" value="sponsor">Sponsor</TabsTrigger>
          <TabsTrigger data-testid="admin-tab-users" value="utenti">Iscritti & Leghe</TabsTrigger>
          <TabsTrigger data-testid="admin-tab-content" value="contenuti">Regolamento & Crediti</TabsTrigger>
          <TabsTrigger data-testid="admin-tab-branding" value="branding">Design & Branding</TabsTrigger>
          <TabsTrigger data-testid="admin-tab-maintenance" value="manutenzione">Manutenzione</TabsTrigger>
        </TabsList>
        <TabsContent value="gara"><RaceTab /></TabsContent>
        <TabsContent value="piloti"><PilotsTab /></TabsContent>
        <TabsContent value="eventi"><EventsTab /></TabsContent>
        <TabsContent value="sponsor"><SponsorsTab /></TabsContent>
        <TabsContent value="utenti"><UsersTab /></TabsContent>
        <TabsContent value="contenuti"><ContentTab /></TabsContent>
        <TabsContent value="branding"><BrandingTab /></TabsContent>
        <TabsContent value="manutenzione"><MaintenanceTab /></TabsContent>
      </Tabs>
    </div>
  );
}
